import React, {useEffect, useState} from 'react'
import {convertirNumeroConComas} from '../../../../utils/numbers.utils'
import { useDispatch, useSelector } from 'react-redux'
import { sujetoExcluidoFormClienteHandleChange } from '../../../../actions/sujeto-excluido/sujetoExcluidoCliente.actions'
import { State } from '../../../../reducers'
import TableDTE from '../../../../components/Tables/TableDTE/TableDTE'

const TablaFacturacionSE = (props: any) => {
  const [rows, setRows] = useState([])

  useEffect(() => {
    const productos = props.rows.map((p: any, i: number) => ({
      ...p,  unidadMedida: p.unidadMedida, index: i, tipoNew: p.tipo === "p" ? "Producto" : "Servicio", cantidadNew: p.cantidad, precioNew: `$${convertirNumeroConComas(p.precio)}`, cantidadDescuentoNew: `$${convertirNumeroConComas(p.cantidadDescuento)}`, ventasGravadas: `$${convertirNumeroConComas(p.total)}`, ventasExentas: "$0.00", ventasSujetas: "$0.00", }))
    setRows(productos)
  }, [props.rows])

  return (
    <><TableDTE rows={rows} openModalEliminar={props.openModalEliminar} openModalEditar={props.openModalEditar} sinAcciones={props?.sinAcciones} idDoc={props?.idDoc} />
      {props?.sinAcciones !== true && <CheckRetencionRenta />}
      <div className="cf-calculos-producto" style={{width: '100%'}}>
        <table>
          <tbody>
            <TableRowResponsiveCard text={"Suma de operaciones de ventas no sujetas"} valor={props?.datos?.total} className="cf-subtotal"/>
            <TableRowResponsiveCard text={"Impuesto al Valor Agregado 13%"}  valor={"0.00"} className="cf-subtotal" />
            <TableRowResponsiveCard text={"Subtotal"}  valor={props?.datos?.total} className="cf-subtotal" />
            <TableRowResponsiveCard text={"IVA percibido 1%"}  valor={props?.datos?.totalIvaPercibido} className="cf-subtotal" />
            <TableRowResponsiveCard text={"IVA retenido 1%"}  valor={props?.datos?.totalImpuesto2} className="cf-subtotal" />
            <TableRowResponsiveCard  text={"Retención renta 10%"}  valor={props?.datos?.totalRetencionRenta} className="cf-descuento" />
            <TableRowResponsiveCard text={"Monto total a la operación"}  valor={props?.datos?.totalMontoOperacion} className="cf-total" />
            <TableRowResponsiveCard text={"Total"}  valor={props?.datos?.totalPagar} className="cf-total" />
          </tbody>
        </table>
      </div></>
  )
}

const TableRowResponsiveCard = (props: any) => {
  return (
    <tr className={props?.className}>
      <td>{props.text}</td>
      <td>${convertirNumeroConComas(props?.valor) ?? '0.00'}</td>
    </tr>
  )
}

const CheckRetencionRenta = (props: any) => {
  const checkReteRenta = useSelector((state: State) => state.sujetoExcluido.formCliente.checkReteRenta)
  const dispatch = useDispatch();
  const handleChangeCheckRetencionRenta = () => dispatch(sujetoExcluidoFormClienteHandleChange({checkReteRenta: !checkReteRenta}))
  return (
    <div className='w-100'>
      <div className='label-input'>
        <label className='container-checkbox m'>
          No realizar retención renta<input autoFocus type='checkbox' name='checkCF' checked={checkReteRenta} onChange={handleChangeCheckRetencionRenta}/><span className='checkmark-checkbox'></span>
        </label>
      </div>
    </div>
  )
}

export default TablaFacturacionSE
